module.exports = __webpack_public_path__ + "static/media/ClearWaypoint.e2913211.svg";